import store from 'client/store';

// Do not show customers the policy group item table page unless they're
// either an admin with billing, manager, or regular admin from a provider org
export default function policyGroupTemplateGuard(to, from, next, storeInstance = store) {
  const { path } = to;
  const settingsModule = 'SettingsModule';
  const isAdminWithBilling = storeInstance.getters[`${settingsModule}/isAdminWithBilling`];
  const isAdmin = storeInstance.getters[`${settingsModule}/isAdmin`];
  const isManager = storeInstance.getters[`${settingsModule}/isManager`];

  const hasRole = isAdminWithBilling || isAdmin || isManager;

  let route; // undefined means continue;

  // Don't stop a logout
  if (path.indexOf('/logout') === 0) {
    next();
    return;
  }

  if (path.indexOf('/groups/configuration/grouptemplates') === 0 && !hasRole) {
    // If we're trying to hit the policy group template item list page,
    // bounce back to main configuration groups page
    route = '/groups/configuration';
  }

  next(route);
}
